import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Paper,
  IconButton,
  CircularProgress,
  Autocomplete,
  TextField 
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom'; 

// inside component

const TOTAL_STEPS = 8;
const heightOptions = [
  '4\'6" (137 cm)', '4\'7" (140 cm)', '4\'8" (142 cm)', '4\'9" (145 cm)',
  '4\'10" (147 cm)', '4\'11" (150 cm)', '5\'0" (152 cm)', '5\'1" (155 cm)',
  '5\'2" (157 cm)', '5\'3" (160 cm)', '5\'4" (163 cm)', '5\'5" (165 cm)',
  '5\'6" (168 cm)', '5\'7" (170 cm)', '5\'8" (173 cm)', '5\'9" (175 cm)',
  '5\'10" (178 cm)', '5\'11" (180 cm)', '6\'0" (183 cm)', '6\'1" (185 cm)',
  '6\'2" (188 cm)', '6\'3" (190 cm)', '6\'4" (193 cm)', '6\'5" (196 cm)',
  '6\'6" (198 cm)', '6\'7" (201 cm)', '6\'8" (203 cm)', '6\'9" (206 cm)',
  '6\'10" (208 cm)', '6\'11" (211 cm)', '7\'0" (213 cm)'
];

const Step9HeightSelection = ({ onBack, onNext, formData, setFormData, currentStep, showHeader = true, className }) => {
  const [height, setHeight] = useState(formData.height || '');

  const [loading, setLoading] = useState(false);

  const handleContinue = () => {
    if (!height) return;
    setLoading(true);

    // Simulate async work, replace with real API call if needed
    setTimeout(() => {
      setLoading(false);
      setFormData({ ...formData, height });
      onNext();
    }, 1500);
  };


  const renderSegmentedProgressBar = () => (
    <Box display="flex" gap={1} mb={1}>
      {Array.from({ length: TOTAL_STEPS }).map((_, index) => (
        <Box
          key={index}
          flex={1}
          height={4}
          borderRadius={5}
          sx={{
            backgroundColor: index < currentStep ? '#0D99FF' : '#e0e0e0',
            transition: 'background-color 0.3s ease',
          }}
        />
      ))}
    </Box>
  );

  return (
    <Box display="flex" alignItems="start" justifyContent="center" className={className} sx={{ paddingTop: { xs: 0, sm: 13, md: 6, }, paddingBottom: { xs: 0, sm: 3, md: 6, }, }}>
      <Paper elevation={3} sx={{ p: { xs: '20px 15px', sm: 4, }, maxWidth: 480, width: '100%', borderRadius: { xs: '0', sm: '8px', md: '8px', boxShadow: 'none', }, position: 'relative', }}>
       {showHeader && (
        <>
        {renderSegmentedProgressBar()}

        <IconButton onClick={onBack}>
          <ArrowBackIosNewIcon />
        </IconButton> 
        </>
       )}
        <Typography variant="h5" fontWeight={600} mb={2} align="center" fontFamily="ivypresto-headline, serif">
          How Tall Are You?
        </Typography>
        <Typography variant="body2" color='rgba(0, 0, 0, 0.7)' align="center" mb={3}>
          Let your potential matches know your height.
        </Typography>

        <FormControl fullWidth> 

         <Autocomplete
  options={heightOptions}
  value={height}
  onChange={(event, newValue) => setHeight(newValue)}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Your Height (ft & in or cm)"
      placeholder="Select or search your height"
      variant="outlined"
      InputLabelProps={{
        sx: {
          fontSize: '14px', transform: 'translate(14px, 11px) scale(1)',
              '&.MuiInputLabel-shrink': {
                top: '0px',
                transform: 'translate(14px, -9px) scale(0.75)',
              },
        },
      }}
    />
  )}
  fullWidth
  sx={{
    '& .MuiOutlinedInput-root': {
      height: 44,
      borderRadius: '8px',
      fontSize: '14px',
    },
    '& .MuiAutocomplete-inputRoot': {
      py: '10px !important',
    },
    '& .MuiInputBase-input': {
      fontSize: '14px',
    }, 
  }}
   slotProps={{
              popper: {
                sx: {
                  '& .MuiAutocomplete-listbox': {
                    fontSize: '13px',
                    '& .MuiAutocomplete-option': {
                      fontSize: '13px',
                    },
                  },
                },
              },
            }}
/>

        </FormControl>



        <Button
          variant="contained"
          fullWidth
          onClick={handleContinue}
          sx={{
            mt: 4,
            height: 45,
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: '600',
            backgroundColor: loading ? '#A1887F' : '#5F3D23',
            '&:hover': {
              bgcolor: loading ? '#A1887F' : '#2B1E1A',
            },
          }}
          disabled={!height || loading}
        >
          {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'Continue'}
        </Button>

      </Paper>
    </Box>
  );
};

export default Step9HeightSelection;
